module.exports = __webpack_public_path__ + "static/product2-5abb51eed8c82bbc3694905b1bfdc8b2.png";